module.exports = __webpack_public_path__ + "static/media/empty_avatar.5162b062.svg";